import Reviews from '../../../components/Reviews'

const Review = ({data} = {}) => {
  return (
    <div className="section-review">
      { (data.awardTitle || data.awardDescription) &&
        <div className="section-review__intro">
          { data.awardTitle &&
            <h2>{data.awardTitle}</h2>
          }
          { data.awardDescription &&
            <p className="subtitle_1">{data.awardDescription}</p>
          }
          <div className="section-review__intro__awards__img" />
        </div>
      }
      { (data.reviewTitle || data.reviewDescription) &&
        <Reviews data={data.reviewFooterDescription}>
          { data.reviewTitle &&
            <h3>{data.reviewTitle}</h3>
          }
          { data.reviewDescription &&
            <p>
              {data.reviewDescription}
            </p>
          }
        </Reviews>
      }
    </div>
  );
};

export default Review;
